<template>
    <div class="pichi-tunnel-info">
        <div class="pichi-tunnel">
            <div class="subject">
                ピッチトンネル
            </div>
            <div class="child-flex">
                <div class="value">
                    幅：{{ Math.round(pichiRelSide * 10) / 10 }}cm
                </div>
                <div class="value">
                    奥行：{{ Math.round(pichiDepth * 10) / 10 }}cm
                </div>
            </div>
        </div>
        <div class="home-plate">
            <div class="subject">
                ホームプレート
            </div>
            <div class="child-flex">
                <div class="value">
                    幅：{{ Math.round(homeRelSide * 10) / 10 }}cm
                </div>
                <div class="value">
                    奥行：{{ Math.round(homeDepth * 10) / 10 }}cm
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["pichiRelSide", "pichiDepth", "homeRelSide", "homeDepth"]
}
</script>

<style scoped>
.pichi-tunnel-info {
    position: absolute;
    background: rgba(51, 51, 51, 0.95);
    bottom: 90px;
    right: 70px;
    width: 250px;
    font-size: 15px;
    color: #fff;
    padding: 10px;
    margin-right: 14px;
}

.child-flex {
    display: flex;
    margin: 5px 10px 0;
}

.pichi-tunnel .subject {
    border-left: 3px solid #ffc373;
    padding-left: 5px;
}

.home-plate .subject {
    border-left: 3px solid #e20c16;
    padding-left: 5px;
}

.value {
    font-size: 12px;
}

.pichi-tunnel {
    padding-bottom: 15px;
}
</style>

